import ufeApi from 'services/api/ufeApi';

/**
 * Fetches a page of order history with order details for a user profile.
 *
 * @param {string} userProfileId The user profile identifier.
 * @param {number} page The current page number to request.
 * @param {number} limit The number of items to request per page.
 * @returns {Promise<{numOrders: number, orders: Array}>} The order count and order list.
 */
async function getOrderHistoryWithDetails(userProfileId, page, limit) {
    const url = `/api/users/profiles/${userProfileId}/orders?` + `currentPage=${page}&` + `itemsPerPage=${limit}&` + 'orderDetails=true';
    const data = await ufeApi.makeRequest(url, { method: 'GET' });

    if (data.errorCode) {
        throw data;
    }

    return {
        numOrders: data.orderCount,
        orders: data.orders
    };
}

export default getOrderHistoryWithDetails;
